import PropTypes from 'prop-types'

import { Box } from '@mui/material'
import TimeLineMobile from './TimeLineMobile'

import { addressPropTypes } from '../../../../common/propTypes'
import Address from '../../../../ui/components/Address'

import styles from '../styles'

const OriginDestinationSection = ({ data }) => {
  return (
    <>
      <Box
        sx={{
          ...styles.addresses,
        }}
      >
        <TimeLineMobile
          state={data.state}
          shipmentInfo={data.shipmentInfo}
          shipmentStatus={data.shipmentStatus}
        />
        <Address
          data={data.from}
          sx={{ ...styles.address, ...styles.addresFrom }}
        />
        <Address
          data={data.to}
          sx={{ ...styles.address, ...styles.addressTo }}
        />
      </Box>
    </>
  )
}

OriginDestinationSection.propTypes = {
  data: PropTypes.shape({
    shipmentStatus: PropTypes.string,
    from: addressPropTypes,
    to: addressPropTypes,
  }),
}

export default OriginDestinationSection
